// Thin re-export barrel. TripEditView's implementation moved to Views/Trip/EditView.tsx
// as part of the TripView decomposition (#728). It is kept here so external importers
// (CruiseView, TripView) and the flat data test keep importing from "./TripEditView"
// unchanged.
export { TripEditView, TripEditViewData } from "./Trip/EditView"
